export default __webpack_public_path__ + "static/media/switcher-disable.64f69821.svg";